module.exports = __webpack_public_path__ + "img/unknown-file-icon.269eabd9.svg";